import React from "react";

import style from "./styles.module.css";

import CoticLogo from "../../image/LOGO-COTIC_NOVA.svg";

export default function Footer() {
  return (
    <div className={style.container}>
      <div className={style.row}>
        <div className={style.sigla}>SSPDS.CE.GOV.BR</div>
        <div className={style.endereco}>
          <h2>SECRETARIA DA SEGURANÇA PÚBLICA E DEFESA SOCIAL</h2>

          <p>
            AV. BEZERRA DE MENEZES, 581 - SÃO GERARDO FORTALEZA, CE - CEP:
            60.325-003 TELEFONE: (85) 3101-6501
          </p>
        </div>
        <div className={style.redesSociais}>
          <p>Desenvolvido por</p>
          <div className={style.icon}>
            <img src={CoticLogo} alt="Logo cotic" />
          </div>
          <h2>
            © 2017 - 2021 – GOVERNO DO ESTADO DO CEARÁ TODOS OS DIREITOS
            RESERVADOS
          </h2>
        </div>
      </div>
    </div>
  );
}
